import React from 'react';
import { cn } from '../../lib/cn';
export function Field({
  label,
  children,
  className
}: {
  label: string;
  children: React.ReactNode;
  className?: string;
}) {
  return <label className={cn('flex flex-col gap-1.5', className)} data-id="element-585" data-mp="3v8ob6klfb69a">
      <span className="text-[13px] font-medium text-ink-soft" data-id="element-586" data-mp="3v7d3i9ouxecw">{label}</span>
      {children}
    </label>;
}
export const inputBase = 'w-full h-10 px-3 rounded-xl border border-line bg-white text-sm text-ink placeholder:text-ink-soft/60 transition-colors focus:outline-none focus:border-accent/50 focus:ring-2 focus:ring-accent/15';
export function Input(props: React.InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} className={cn(inputBase, props.className)} data-id="element-587" data-mp="hw4d1dzn2r4p" />;
}
export function Textarea(props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea {...props} className={cn(inputBase, 'h-auto py-2.5 leading-relaxed resize-y min-h-[90px]', props.className)} data-id="element-588" data-mp="rtisba9tt9vf" />;
}